import { useContext } from 'react';

import { LaneType } from 'common-types';
import { PERMISSION_KEYS } from 'constants-permissions';
import { UserDataContext } from 'lane-shared/contexts';
import hasPermission from 'lane-shared/helpers/hasPermission';

import { useCanViewAllPmTasks } from './useCanViewAllPmTasks';

export function usePmTaskPermissions(channelId?: LaneType.UUID) {
  const { user } = useContext(UserDataContext);

  const canViewAllTasks = useCanViewAllPmTasks(channelId);

  const canUploadAttachments =
    user?.isSuperUser ||
    hasPermission(
      user?.roles,
      [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_PM_TASK_ATTACH_FILE],
      channelId,
      false
    );

  const canEditStatus =
    user?.isSuperUser ||
    hasPermission(
      user?.roles,
      [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_PM_TASK_EDIT_STATUS],
      channelId,
      false
    );

  const canAssignIndividual =
    user?.isSuperUser ||
    hasPermission(
      user?.roles,
      [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_PM_TASK_EDIT_ASSIGNEE],
      channelId,
      false
    );

  const canAssignTeam =
    user?.isSuperUser ||
    hasPermission(
      user?.roles,
      [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_PM_TASK_EDIT_ASSIGNTEAM],
      channelId,
      false
    );

  const hasEquipmentAccess =
    hasPermission(
      user?.roles,
      [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_EQUIPMENT_VIEW],
      channelId,
      false
    ) || true;

  const hasScheduleAccess = hasPermission(
    user?.roles,
    [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_PM_SCHEDULE_VIEW],
    channelId,
    false
  );

  const canBeAssigned = hasPermission(
    user?.roles,
    [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_SERVICE_REQUEST_ASSIGNABLE_TEAM],
    channelId
  );

  const canCreateServiceRequest =
    user?.isSuperUser ||
    hasPermission(
      user?.roles,
      [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_SERVICE_REQUEST_CREATE],
      channelId,
      false
    );

  return {
    canViewAllTasks,
    canUploadAttachments,
    canEditStatus,
    canAssignIndividual,
    canAssignTeam,
    hasEquipmentAccess,
    hasScheduleAccess,
    canBeAssigned,
    canCreateServiceRequest,
  };
}
